import {DialogLayout} from "base/dialog/components";

const CompleteProcessDialog = ({isDialogOpen, setIsDialogOpen, onComplete}) => {
    const handleDialog = isOpen => {
        setIsDialogOpen(false);
    };

    const handleConfirm = () => {
        setIsDialogOpen(false);
        onComplete();
    };

    return (
        <DialogLayout
            dialogTitle={`Tem certeza de que deseja completar o processo?`}
            mainActionText="Sim"
            secondaryActionText="Não"
            onMainActionClick={handleConfirm}
            onHandleDialog={handleDialog}
            isDialogOpen={isDialogOpen}
            mainActionColor="secondary"
        />
    );
};

export default CompleteProcessDialog;
